import { Enumerable, Kbo } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";
import { GridColumn } from "@models/configurators/grid-column";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { UiObject } from "@models/configurators/ui-object";
import { IGridRow } from "@models/entity-models";

@Kbo(CToken.GridRow)
export class GridRow extends UiObject implements IGridRow {

    constructor(kom: KbObjectManager) {
        super(kom);
    }

    public horizontalAlignment: string;
    public verticalAlignment: string;
    public spaceBetweenItems: string;
    public collapseOnMobile: boolean;
    
    private _columns: GridColumn[];
    @Enumerable()
    public get columns(): GridColumn[] {
        if (!this._columns) this._columns = [];
        return this._columns;
    }
    public set columns(val) {
        this._columns = val;
    }

    // public visible: boolean;


    public getChildrenOfType<T extends UiObject>(...tokens: CToken[]): T[] {
        return this.filterChildren<T>(tokens,
            this.columns
        );
    }

    public allowedChildren(rootType: CToken): CToken[] {
        // implement in derived classes
        return [
            CToken.GridColumn
        ];
    }
}
